import moment from 'moment'
import 'moment/locale/sv'

moment.locale('sv')

export const getFormattedDate = (createdAt, showTime) => {
  const notThisYear = moment(createdAt)
    .fromNow()
    .includes('år')

  let dateFormat
  if (showTime) {
    dateFormat = notThisYear ? 'D MMM YYYY HH:mm' : 'D MMM HH:mm'
  } else {
    dateFormat = notThisYear ? 'D MMM YYYY' : 'D MMM'
  }

  const checkTodayOrYesterday = (word) => {
    return word === 'Idag' || word === 'Igår'
  }

  const todayOrYesterday = moment(createdAt)
    .calendar()
    .split(' ')
    .some(checkTodayOrYesterday)

  const dateStamp = moment(createdAt).format(dateFormat)
  const timeStamp = moment(createdAt).calendar()

  const date = todayOrYesterday ? timeStamp : dateStamp
  return date
}

// only returns a value if timestamp is within today or yesterday
export const lastActive = (timestamp) => {
  const momentFormat = moment(timestamp)
  const today = momentFormat.isSame(moment(), 'day')
  const yesterday = momentFormat.isSame(moment().add(-1, 'days'), 'day')
  const prefix = 'Senast aktiv:'
  const format = moment(timestamp).format('HH:mm')
  let text

  if (today) {
    text = `${prefix} Idag ${format}`
  }

  if (yesterday) {
    text = `${prefix} Igår ${format}`
  }

  return text
}
